module.exports = __webpack_public_path__ + "static/3-cb2cf3fc47846779c7e4f7343ce17cd6.jpg";